import React from 'react';

const NotFound = () => {
    return (
        <div>
            <h1>This is Not Found Page</h1>
        </div>
    );
};

export default NotFound;